import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";

import Routes from "./routes";
import theme from "./styles/theme";
import { SearchProvider } from "./contexts/SearchContext";
import { AppProvider } from "./contexts/AppContext";
import queryClient from "./config/queryClient";
import ErrorBoundary from "./components/ErrorBoundary";

import "react-toastify/dist/ReactToastify.css";

import GlobalStyle from "./styles/global";
import ToastStyle from "./styles/toast";

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <AppProvider>
          <SearchProvider>
            <BrowserRouter>
              <GlobalStyle />
              <ToastStyle />
              <Routes />
            </BrowserRouter>
          </SearchProvider>
        </AppProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
